<template>
  <container :isModal="false" :loading="stateLoading">
    <template v-slot:header>
      <h4>Usuários do cliente</h4>
    </template>
    <template v-slot:body>
      <template v-if="stateReady">
        <div class="p-formgrid p-grid">
          <!-- enter nos filtros submeteria o form do cliente -->
          <div class="p-field p-fluid p-col-12 p-md-4">
            <input-with-label label="Filtrar por login" v-slot="l">
              <InputText
                v-model="filtroLogin"
                :id="l.id"
                autocomplete="off"
                @keydown.enter.prevent
              />
            </input-with-label>
          </div>
          <div class="p-field p-fluid p-col-12 p-md-4">
            <input-with-label label="Filtrar por nome" v-slot="l">
              <InputText
                v-model="filtroNome"
                :id="l.id"
                autocomplete="off"
                @keydown.enter.prevent
              />
            </input-with-label>
          </div>
          <div class="p-field p-fluid p-col-12 p-md-4">
            <input-with-label label="Filtrar por tipo" v-slot="l">
              <Dropdown
                v-model="filtroTipo"
                :options="tiposFiltro"
                optionLabel="descricao"
                optionValue="tipo"
                :showClear="true"
                :id="l.id"
              />
            </input-with-label>
          </div>
          <div class="p-col-12 p-mb-2 p-text-right">
            <Button
              icon="fas fa-user-plus"
              label="Novo usuário"
              class="p-button-rounded"
              :disabled="stateLoading"
              @click="abrirUsuario()"
            />
          </div>
          <div class="p-col-12">
            <DataTable
              class="tabela-usuarios"
              :value="usuariosFiltrados"
              dataKey="idUsuario"
              responsiveLayout="stack"
              :stripedRows="true"
              :showGridlines="true"
              :paginator="usuariosFiltrados.length > linhasPorPagina"
              :rows="linhasPorPagina"
              v-model:first="primeiraLinha"
            >
              <template #empty>
                <span
                  v-text="
                    possuiFiltro
                      ? 'Nenhum usuário encontrado para os filtros informados.'
                      : 'Nenhum usuário cadastrado.'
                  "
                />
              </template>
              <Column field="login" header="Login" />
              <Column field="nome" header="Nome" />
              <Column header="Tipo">
                <template #body="slotProps">
                  <span v-text="getDescricaoTipo(slotProps.data.tipo)" />
                </template>
              </Column>
              <Column header="Ativo">
                <template #body="slotProps">
                  <span v-text="slotProps.data.ativo ? 'Sim' : 'Não'" />
                </template>
              </Column>
              <Column header="Último acesso">
                <template #body="slotProps">
                  <span
                    v-text="formatDateTime(slotProps.data.dataUltimoLogin)"
                  />
                </template>
              </Column>
              <Column>
                <template #body="slotProps">
                  <Button
                    icon="fas fa-edit"
                    class="p-button-rounded"
                    v-title="'Alterar usuário'"
                    :disabled="
                      stateLoading ||
                        !amIAllowed('edit', slotProps.data.permissionInfo)
                    "
                    @click="abrirUsuario(slotProps.data)"
                  />
                </template>
              </Column>
            </DataTable>
          </div>
        </div>
      </template>

      <Dialog
        v-model:visible="dialogAberto"
        :header="entity.idUsuario ? 'Alterar usuário' : 'Novo usuário'"
        :modal="true"
        :style="{ width: '95vw', maxWidth: '600px' }"
        @hide="fecharUsuario()"
      >
        <form :id="stateId + '_form'" @submit.prevent="salvarUsuario">
          <fieldset :disabled="stateLoading" class="p-pt-0">
            <div class="p-formgrid p-grid">
              <div class="p-field p-fluid p-col-12 p-md-6">
                <input-with-label label="Login" :required="true" v-slot="l">
                  <InputText
                    v-model="entity.login"
                    :id="l.id"
                    :required="l.required"
                    :disabled="!!entity.idUsuario"
                    maxlength="250"
                    autocomplete="off"
                  />
                </input-with-label>
              </div>
              <div class="p-field p-fluid p-col-12 p-md-6">
                <input-with-label
                  label="Senha"
                  :subLabel="entity.idUsuario ? 'Em branco mantém a atual' : ''"
                  :required="!entity.idUsuario"
                  v-slot="l"
                >
                  <Password
                    v-model="entity.senha"
                    :id="l.id"
                    :required="l.required"
                    maxlength="250"
                    :feedback="false"
                    autocomplete="new-password"
                    toggleMask
                  />
                </input-with-label>
              </div>
              <div class="p-field p-fluid p-col-12 p-md-6">
                <input-with-label label="Tipo" :required="true" v-slot="l">
                  <Dropdown
                    v-model="entity.tipo"
                    :options="tiposDisponiveis"
                    optionLabel="descricao"
                    optionValue="tipo"
                    :id="l.id"
                    :required="l.required"
                    :disabled="
                      isTransportador || isUsuarioR || isProprioUsuario
                    "
                  />
                </input-with-label>
              </div>
              <div class="p-field p-fluid p-col-12 p-md-6">
                <input-with-label label="Ativo?" v-slot="l" :floatLabel="false">
                  <InputSwitch
                    v-model="entity.ativo"
                    :id="l.id"
                    :disabled="isProprioUsuario"
                  />
                </input-with-label>
              </div>
              <div class="p-col-12">
                <small v-if="isProprioUsuario" class="p-d-block">
                  Seu próprio usuário: só é possível trocar a senha.
                </small>
                <small v-else-if="isUsuarioR" class="p-d-block">
                  Usuário GovPass (R): o tipo não pode ser alterado.
                </small>
                <small v-else-if="isTransportador" class="p-d-block">
                  Usuário de transportador: o tipo não pode ser alterado aqui.
                </small>
                <small v-else-if="!entity.idUsuario" class="p-d-block">
                  Usuários de transportador (C) são criados na tela do
                  Transportador.
                </small>
                <small v-if="isLoginGovpass(entity.login)" class="p-d-block">
                  Usuários "root-" entram com a senha do usuário root; a senha
                  informada aqui não é usada no login.
                </small>
              </div>
            </div>
          </fieldset>
        </form>
        <template #footer>
          <Button
            label="Cancelar"
            class="p-button-rounded p-button-text"
            :disabled="stateLoading"
            @click="fecharUsuario()"
          />
          <Button
            type="submit"
            :form="stateId + '_form'"
            label="Salvar usuário"
            class="p-button-rounded"
            :disabled="stateLoading"
          />
        </template>
      </Dialog>
    </template>
  </container>
</template>

<script lang="ts">
import {
  defineComponent,
  reactive,
  toRefs,
  onMounted,
  computed,
  watch,
  Ref
} from "vue";
import { useAuth, PermissionPayload } from "../../../modules/auth";
import { useToast } from "../../../modules/message";
import { formatDateTime } from "../../../modules/utils";
import {
  ClienteUsuarioPayload,
  TipoUsuario,
  TIPOS_USUARIO,
  useClienteUsuarioService
} from "../../../modules/business/cliente/clienteUsuarioBusiness";

interface ClienteUsuariosState {
  usuarios: Array<ClienteUsuarioPayload>;
  entity: ClienteUsuarioPayload;
  dialogAberto: boolean;
  filtroLogin: string;
  filtroNome: string;
  filtroTipo: TipoUsuario | null;
  primeiraLinha: number;
  stateReady: boolean;
  stateId: string;
  loadings: Array<Ref<boolean>>;
}

/**
 * Aba "Usuários" do cadastro do cliente. Cada usuário é salvo pelo próprio
 * diálogo, independente do botão Salvar do cliente. Sem idCliente trabalha
 * com o cliente do administrador logado.
 */
export default defineComponent({
  props: {
    idCliente: Number,
    parentLoading: Boolean
  },
  setup(props) {
    const novoUsuario = (): ClienteUsuarioPayload => ({
      login: "",
      senha: "",
      tipo: "F",
      ativo: true
    });

    const state = reactive<ClienteUsuariosState>({
      usuarios: [],
      entity: novoUsuario(),
      dialogAberto: false,
      filtroLogin: "",
      filtroNome: "",
      filtroTipo: null,
      primeiraLinha: 0,
      stateReady: false,
      stateId:
        "state-" +
        Math.random()
          .toString(36)
          .substring(2),
      loadings: []
    });

    const amIAllowed = (
      authority: string,
      permissionInfo?: PermissionPayload | string | null
    ) => {
      return useAuth().amIAllowed(authority, permissionInfo);
    };

    const stateLoading = computed(() => {
      return state.loadings.length !== 0 || !!props.parentLoading;
    });

    const linhasPorPagina = 20;

    // o tipo R (único, da GovPass) não é oferecido em nenhum ponto da tela
    const tiposFiltro = TIPOS_USUARIO.filter((t) => t.tipo !== "R");

    const contemTexto = (valor?: string | null, filtro?: string) =>
      !filtro || (valor ?? "").toLowerCase().includes(filtro);

    const possuiFiltro = computed(
      () =>
        !!state.filtroLogin.trim() ||
        !!state.filtroNome.trim() ||
        !!state.filtroTipo
    );

    // a lista vem inteira do backend; os filtros sao locais e combinados (E)
    const usuariosFiltrados = computed(() => {
      const login = state.filtroLogin.trim().toLowerCase();
      const nome = state.filtroNome.trim().toLowerCase();
      return state.usuarios.filter(
        (u) =>
          contemTexto(u.login, login) &&
          contemTexto(u.nome, nome) &&
          (!state.filtroTipo || u.tipo === state.filtroTipo)
      );
    });

    watch(
      () => [state.filtroLogin, state.filtroNome, state.filtroTipo],
      () => (state.primeiraLinha = 0)
    );

    const isTransportador = computed(
      () => !!state.entity.idUsuario && state.entity.tipo === "C"
    );

    const isProprioUsuario = computed(
      () =>
        !!state.entity.idUsuario &&
        state.entity.idUsuario === useAuth().user?.value?.idUsuario
    );

    const isUsuarioR = computed(
      () => !!state.entity.idUsuario && state.entity.tipo === "R"
    );

    // R e C só aparecem para exibir um usuário que já é desse tipo (campo travado)
    const tiposDisponiveis = computed(() =>
      TIPOS_USUARIO.filter(
        (t) =>
          (t.tipo !== "R" || isUsuarioR.value) &&
          (t.tipo !== "C" || isTransportador.value)
      )
    );

    const { getDescricaoTipo, isLoginGovpass } = useClienteUsuarioService();

    const carregarUsuarios = (): Promise<void> => {
      const { data, loading, getUsuarios } = useClienteUsuarioService();
      state.loadings.push(loading);
      return getUsuarios(props.idCliente)
        .then(() => {
          state.usuarios = data.value ?? [];
          state.loadings.splice(state.loadings.indexOf(loading), 1);
        })
        .catch(() => {
          state.loadings.splice(state.loadings.indexOf(loading), 1);
        });
    };

    const abrirUsuario = (usuario?: ClienteUsuarioPayload) => {
      state.entity = usuario ? { ...usuario, senha: "" } : novoUsuario();
      state.dialogAberto = true;
    };

    const fecharUsuario = () => {
      state.dialogAberto = false;
      state.entity = novoUsuario();
    };

    const salvarUsuario = () => {
      const { loading, saveUsuario } = useClienteUsuarioService();
      const payload: ClienteUsuarioPayload = {
        idUsuario: state.entity.idUsuario,
        login: state.entity.login?.trim(),
        senha: state.entity.senha ? state.entity.senha : null,
        tipo: state.entity.tipo,
        ativo: state.entity.ativo
      };
      state.loadings.push(loading);
      saveUsuario(props.idCliente, payload)
        .then(() => {
          state.loadings.splice(state.loadings.indexOf(loading), 1);
          useToast().success("Usuário salvo com sucesso");
          fecharUsuario();
          carregarUsuarios();
        })
        .catch(() => {
          // erro já exibido pelo useApi; mantém o diálogo aberto para correção
          state.loadings.splice(state.loadings.indexOf(loading), 1);
        });
    };

    onMounted(() => {
      carregarUsuarios().then(() => (state.stateReady = true));
    });

    return {
      stateLoading,
      usuariosFiltrados,
      possuiFiltro,
      tiposFiltro,
      linhasPorPagina,
      tiposDisponiveis,
      isTransportador,
      isUsuarioR,
      isProprioUsuario,
      amIAllowed,
      abrirUsuario,
      fecharUsuario,
      salvarUsuario,
      getDescricaoTipo,
      isLoginGovpass,
      formatDateTime,
      ...toRefs(state)
    };
  }
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
/* mesmo zebrado da aba Clientes (representados) */
.tabela-usuarios :deep(.p-datatable-tbody > tr:nth-child(odd)) {
  background: $bg-surface !important;
}

.tabela-usuarios :deep(.p-datatable-tbody > tr:nth-child(even)) {
  background: $bg-color !important;
}

.tabela-usuarios :deep(.p-datatable-thead > tr > th),
.tabela-usuarios :deep(.p-datatable-tbody > tr > td) {
  border: 1px solid $border-color !important;
}
</style>
